/* ar-brown App (C) 2021 arbrown.co.jp All rights reserved.
 *******************************************************************************
 * Program ID:  Agent.js
 * $Revision:   Ver1.0
 * $Modtime:    $
 *******************************************************************************
 * Author      (作成／更新年月日、担当者)
 *  2021/08/01 Rayoo)li : 新規作成
 *
 * Summary Agent画面
 *
 * Instructions / Preconditions
 *  なし
 *
 *******************************************************************************
 */
import React, { useEffect, useState, useReducer } from "react";
/*  GraphQL API Acess */
import API, { graphqlOperation } from "@aws-amplify/api";
import {
  agencyGroupSortList,
  AdminAgencyPriceGroupSortList,
} from "../graphql/queries";
/*  AWS標準設定 with Login Auth. */
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);
import Grid from "@material-ui/core/Grid";
import { Container, Row, Col,InputGroup, } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import CircularProgress from "@mui/material/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
const useStyles = makeStyles((theme) => ({
  fixedTop: {
    position: "sticky",
    top: 0,
    boxShadow: "0 -1px 0 0 white,0 3px 0 0 #804F29,0 3px 0 0 transparent",
    backgroundColor: "white",
    zIndex: 9,
  },
  textlabel: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "rgb(91,56,9)",
    border: "1px solid #707070",
    color: "white",
    fontWeight: "bold",
    fontSize: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    width:'20%',
  },
  textFieldSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "transparent",
    border: "1px solid #707070",
    borderRadius: "6px",
    color: "black",
    width:'80%'
  },
}));
const customTotal = (from, to, size) => (
  <span
    style={{ marginLeft: "1em" }}
    className="react-bootstrap-table-pagination-total"
  >
    {size} の結果の {from} から {to} を表示しています
  </span>
);
const pageButtonRenderer = ({ page, onPageChange }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onPageChange(page);
  };
  return (
    <button className="btn-secondary btn" type="button" key={page}>
      <li className="page-item">
        <a style={{ color: "white" }} href="#" onClick={handleClick}>
          {page}
        </a>
      </li>
    </button>
  );
};
const sizePerPageRenderer = ({
  options,
  currSizePerPage,
  onSizePerPageChange,
}) => (
  <div className="btn-group" role="group">
    {options.map((option) => (
      <button
        key={option.text}
        type="button"
        onClick={() => onSizePerPageChange(option.page)}
        className={`btn ${
          currSizePerPage === `${option.page}` ? "btn-warning" : "btn-light"
        }`}
      >
        {option.text}
      </button>
    ))}
  </div>
);
const options = {
  paginationSize: 10,
  pageStartIndex: 1,
  showTotal: true,
  withFirstAndLast: true,
  firstPageText: "最初",
  prePageText: "戻る",
  nextPageText: "次へ",
  lastPageText: "最後",
  nextPageTitle: "最初のページ",
  prePageTitle: "プレページ",
  firstPageTitle: "次のページ",
  lastPageTitle: "最後のページ",
  paginationTotalRenderer: customTotal,
  sizePerPageRenderer: sizePerPageRenderer,
  pageButtonRenderer: pageButtonRenderer,
  disablePageTitle: true,
  sizePerPageList: [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "30",
      value: 30,
    },
  ],
};
export const InventoryTable = () => {
  const [inventoryTableList, setInventoryTableList] = useState([]);
  const classes = useStyles();
  const [progress, setProgress] = useState(false);
  const [priceGroup, setPriceGroup] = React.useState('パターンA');
  const QUERY = "QUERY";
  const initialAgencyPrice = { Invs: [] };
  const [ProductCodeList, setProductCodeList] = useState([])
  const [searchValue, setSearchValue] = useState({
    Product_Code: "",
  })
  const reducerAgencyPrice = (state, action) => {
    let obj = [];
    switch (action.type) {
      case QUERY:
        for (let i = 0; i < action.Invs.length; i++) {
          obj.push(action.Invs[i].Admin_Agency_Price_Group);
        }
        return { ...state, Invs: obj };
      default:
        return state;
    }
  };
  let [selectAgencyPriceOptions, setAgencyPriceGroup] = useReducer(
    reducerAgencyPrice,
    initialAgencyPrice
  );
  async function listInvData2() {
    let dataAll = [];
    setProgress(true);
    try {
      setInventoryTableList([]);
      const InvData = await API.graphql(
        graphqlOperation(agencyGroupSortList, {
          Agency_Price_Group: priceGroup,
          sortDirection: "DESC",
          limit: 10000,
        })
      );
      let nextToken = InvData.data.AgencyGroupSortList.nextToken;
      dataAll = InvData.data.AgencyGroupSortList.items;
      while (nextToken !== null) {
        let InvDataSec = await API.graphql(
          graphqlOperation(agencyGroupSortList, {
            Agency_Price_Group: priceGroup,
            sortDirection: "DESC",
            limit: 10000,
            nextToken: nextToken,
          })
        );
        nextToken = InvDataSec.data.AgencyGroupSortList.nextToken;
        for (
          let i = 0;
          i < InvDataSec.data.AgencyGroupSortList.items.length;
          i++
        ) {
          dataAll.push(InvDataSec.data.AgencyGroupSortList.items[i]);
        }
      }
    } catch (err) {
      console.log(err);
    }
    return dataAll
  }
  const TextProductCodeChange = (e, value) => {
    setSearchValue({ ...searchValue, Product_Code: value ? value : "" })
}
  const TextpriceGroupChange = (e, value) => {
    setPriceGroup(value)
  }
  const searchBtn = async () => {
    setProgress(true)
    let arr = [];
    let obj = {};
    let dataAll = [];
    try {
      dataAll = await listInvData2()
    } catch (error) {
        if (error.message === 'No current user') {
            //ユーザープールに障害が発生した場合
            console.log('User pool is invalid.Please reauthenticate.');
            //ログイン画面に戻る
            signOut();
        } else {
            //他のエラーを処理する
            console.log('An error occurred:', error);
        }
    }
    obj = searchValue;
    dataAll.forEach(item => {
      let flag = true
      if (Object.keys(obj).length !== 0) {
        for (let name in obj) {
          if (obj[name] !== "") {
            if (item[name]) {
              if (!(item[name]).includes(obj[name])) {
                flag = false;
                break;
              }
            } else {
              flag = false
              break;
            }
          }
        }
      }
      if (flag === true) {
        arr.push(item)
      }
    })
    arr = multiSort(arr,sortByProductCode)
    setInventoryTableList(arr)
    setProgress(false)
}
  const searchClear = async()=>{
    setProgress(true)
    let arr = [];
    try {
        arr = await listInvData2(priceGroup)
    } catch (error) {
      if (error.message === 'No current user') {
          //ユーザープールに障害が発生した場合
          console.log('User pool is invalid.Please reauthenticate.');
          //ログイン画面に戻る
          signOut();
      } else {
          //他のエラーを処理する
          console.log('An error occurred:', error);
      }
  }
    arr = multiSort(arr,sortByProductCode)
    setSearchValue({Product_Code: ""})
    setPriceGroup('パターンA')
    setInventoryTableList(arr)
    setProgress(false)
  }
  const signOut = async () => {
      await Auth.signOut();
      try {
          await Auth.signOut();
      } catch (error) {
          console.log("error signing out: ", error);
      }
      document.location.reload();
  };
  const getTypePriority = (str) => {
    if (!str || str.trim() === "") return 99;
    const firstChar = str[0];
    if (/^[0-9]/.test(firstChar)) return 1;
    if (/^[a-zA-Z]/.test(firstChar)) return 2;
    if (/^[\u30A0-\u30FF]/.test(firstChar)) return 3;
    if (/^[\u3040-\u309F\u4E00-\u9FFF]/.test(firstChar)) return 4;
    return 5;
  };
  const sortByProductCode = (a, b) => {
    const nameA = a.Product_Code || "";
    const nameB = b.Product_Code || "";
    const priorityA = getTypePriority(nameA);
    const priorityB = getTypePriority(nameB);
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  };
  const multiSort = (arr, ...sortFuncs)=> {
    return arr.sort((a, b) => {
      for (const func of sortFuncs) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
      return 0;
    });
  }
  useEffect(() => {
    async function getInventoryTableList() {
      setProgress(true);
      let dataAll = [];
      let agentGroupID;
      let productCodeList = []
      try {
        const AdminAgencyPriceList = await API.graphql(
          graphqlOperation(AdminAgencyPriceGroupSortList, {
            Admin_Group: "admin",
          })
        );
        //データベースから結果を取得できず、結果は空です
        if (
          AdminAgencyPriceList.data.AdminAgencyPriceGroupSortList.items.length >
          0
        ) {
          agentGroupID = 'パターンA'
              setAgencyPriceGroup({
            type: QUERY,
            Invs: AdminAgencyPriceList.data.AdminAgencyPriceGroupSortList.items,
          });
        }
        const InvData = await API.graphql(
          graphqlOperation(agencyGroupSortList, {
            Agency_Price_Group: agentGroupID,
            sortDirection: "DESC",
            limit: 1000,
          })
        );
        let nextToken = InvData.data.AgencyGroupSortList.nextToken;
        dataAll = InvData.data.AgencyGroupSortList.items;
        while (nextToken !== null) {
          let InvDataSec = await API.graphql(
            graphqlOperation(agencyGroupSortList, {
              Agency_Price_Group: agentGroupID,
              sortDirection: "DESC",
              limit: 1000,
              nextToken: nextToken,
            })
          );
          nextToken = InvDataSec.data.AgencyGroupSortList.nextToken;
          for (
            let i = 0;
            i < InvDataSec.data.AgencyGroupSortList.items.length;
            i++
          ) {
            dataAll.push(InvDataSec.data.AgencyGroupSortList.items[i]);
          }
        }
      } catch (err) {
        console.log(err);
      }
      for (let i = 0; i < dataAll.length; i++) {
        if (dataAll[i].Product_Code) {
          productCodeList.push(dataAll[i].Product_Code)
            }
      }
      dataAll = multiSort(dataAll,sortByProductCode)
      setProductCodeList(Array.from(new Set(productCodeList)))
      setProgress(false);
      setInventoryTableList(dataAll);
    }
    getInventoryTableList();
  }, []);
  const headerStyle = {
    backgroundColor: "white",
    borderBottom: "3px solid #B45210",
    whiteSpace: "nowrap",
    textAlign: "left",
    //minWidth: "130px",
  };
  let columns1 = [
    { dataField: "id", text: "ID", hidden: true },
    {
      dataField: "Product_Code",
      text: "製品コード",
      headerStyle,
      sort: true,
      style: { minWidth: "160px" },
    },
    {
      dataField: "Supplier",
      text: "製造元",
      headerStyle,
      sort: true,
      style: { minWidth: "240px" },
    },
    {
      dataField: "Product_Name_j",
      text: "製品名(和名)",
      headerStyle,
      sort: true,
      style: { minWidth: "750px" },
    },
    {
      dataField: "Product_Name_e",
      text: "製品名(英名)",
      headerStyle,
      sort: true,
      style: { minWidth: "430px" },
    },
    {
      dataField: "Capacity_Display",
      text: "容量",
      headerStyle,
      sort: true,
      style: { minWidth: "110px"},
    },
    {
      dataField: "Catarog_Price",
      text: "定価（税別）",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Wholes_Rate",
      text: "仕切率",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Wholes_Price",
      text: "仕切値（税別）",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Storage_Temp",
      text: "保存温度",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Delivery_Term",
      text: "欠品時目安納期",
      headerStyle,
      sort: true,
      style: { width: "200px", minWidth: "200px"},
    },
    {
      dataField: "Campaign_price",
      text: "キャンペーン価格",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Campaign_partition_rate",
      text: "キャンペーン仕切率",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "LawsRegulations",
      text: "法規制",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Item",
      text: "品目",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Sales_Document_Type",
      text: "販売伝票タイプ",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "instructions",
      text: "内容説明",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Plant",
      text: "プラント",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Plant_Name",
      text: "プラント名",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Salesperson",
      text: "営業員",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Name_Salesperson",
      text: "名称 (営業員)",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Storage_Location",
      text: "保管場所",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "storage_Location_Text",
      text: "保管場所テキスト",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "SalesGroup",
      text: "営業 Grp",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Description_Sales_Group",
      text: "内容説明 (営業グループ)",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "supplier_Code",
      text: "仕入れ先コード",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "supplier_Name",
      text: "仕入れ先名",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Purchasing_Document_Type",
      text: "購買伝票タイプ",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Purchasing_Document_Type_name",
      text: "購買伝票タイプ名",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Price",
      text: "価格",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Purchasing_Organization",
      text: "購買組織",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "purchasing_Group",
      text: "購買グループ",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Purchasing_Group_Name",
      text: "購買グループ名",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Supplier",
      text: "仕入先",
      headerStyle,
      sort: true,
      style: { minWidth: "400px" },
    },
    {
      dataField: "End_user_Toray",
      text: "エンドユーザ(東レ)",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Tax_Code",
      text: "税コード",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "Storage_Location",
      text: "保管場所",
      headerStyle,
      sort: true,
      style: { width: "100px" },
    },
    {
      dataField: "storage_Location_Name",
      text: "保管場所名",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Basic_Quantity_Unit",
      text: "基本数量単位",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "Segment",
      text: "セグメント",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
    {
      dataField: "SegmentContent",
      text: "セグメント内容",
      headerStyle,
      sort: true,
      style: { width: "120px" },
    },
  ];
  const [scrollTableWidth, setscrollTableWidth] = useState("400%");
  window.addEventListener("resize", function () {
    let dom = document.querySelector("#table");
      let width = dom ? `${dom.offsetWidth}px` : '400%';
      setscrollTableWidth(`${width}`)
  });
  return (
    <Container
      style={{
        backgroundColor: "",
        minWidth: "100%",
        minHeight: "74vh",
        height: "100%",
      }}
    >
      <Grid>
        <Grid>
          <Row>
           <div style={{ display: 'flex', marginBottom: "10px",width:"100%" }}>
              <Col>
                <h4
                  style={{
                    textAlign: "left",
                    color: "black",
                    height: 30,
                    width: '20%',
                    borderLeft: "4px solid #804F29",
                    paddingLeft: "4px",
                    whiteSpace:"nowrap"
                  }}>
                  受注設定マスタ
                  </h4>
            </Col>
            <div style={{ width: '80%', height: 140 }}>
                      <div style={{ width: '90%',minWidth:"500px",height: 140, border: '2px solid rgb(191,191,191)', display:"flex", flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
                          <div style={{ width: "50%", height: '25px' }}>
                              <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                                <InputGroup.Text
                                    className={classes.textlabel}
                                    id="basic-name"
                                    style={{ borderRadius: "0px",minWidth:"100px"}}
                                >製品
                                </InputGroup.Text>
                                  <Autocomplete
                                    className={classes.textFieldSearch}
                                    sx={{
                                        display: 'inline-block',
                                        '& input': {
                                            width: 300,
                                            height: 0,
                                        },
                                    }}
                                    options={ProductCodeList}
                                    value={searchValue.Product_Code}
                                    name="Product_Code"
                                    onChange={(e, value) => { TextProductCodeChange(e, value) }}
                                    renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                                    isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                                />
                              </InputGroup>
                          </div>
                          <div style={{ width: "50%", height: '25px', }}>
                              <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                                <InputGroup.Text
                                    className={classes.textlabel}
                                    id="basic-name"
                                    style={{ borderRadius: "0px",minWidth:"100px"}}
                                >価格グループ
                                </InputGroup.Text>
                                <Autocomplete
                                  className={classes.textFieldSearch}
                                  sx={{
                                      display: 'inline-block',
                                      '& input': {
                                          height: 0,
                                      },
                                  }}
                                  options={selectAgencyPriceOptions.Invs}
                                  id="priceGroup"
                                  value={priceGroup}
                                  name="priceGroup"
                                  onChange={(e, value) => { TextpriceGroupChange(e, value) }}
                                  renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                                  isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                                />
                              </InputGroup>
                          </div>
                          <div style={{margin:"auto"}}>
                              <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                              <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
                          </div>
                      </div>
                    </div>
            </div>
          </Row>
        </Grid>
        <Grid>
          <div
            style={{
              width: "100%",
              height: "100%",
              overflowX: "scroll",
              transform: "scaleY(-1)",
            }}
          >
            <div
              style={{
                width: scrollTableWidth,
                height: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
                transform: "scaleY(-1)",
              }}
            >
              <div style={{ direction: "ltr" }}>
                <BootstrapTable
                  id="table"
                  striped={true}
                  hover={true}
                  wrapperClasses="boo bg-white"
                  bootstrap4
                  keyField="id"
                  data={inventoryTableList}
                  columns={columns1}
                  noDataIndication={"no results found"}
                  pagination={paginationFactory(options)}
                  headerClasses={classes.fixedTop}
                />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "55%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress
          size="3rem"
          disableShrink
          sx={{
            color: "#3f51b5",
            margin: "auto",
            display: progress ? "block" : "none",
            marginLeft: "60px",
          }}
        />
      </div>
    </Container>
  );
};
export default InventoryTable;
